<template>
  <div>
    <common-table :table-columns="tableColumns"
                  :url="url" :operate="operate"
                  :form-fields="formFields"
                  :permission="permission"
                  :buttons="buttons"
                  :searchs="searchs"
                  @returnId="returnId"
                  ref="table"></common-table>
    <div class="dialog">
      <el-dialog title="登录二维码"
                 :visible.sync="showLoginDialog"
                 custom-class="common-dialog"
                 :close-on-click-modal="false"
                 width="30%">
        <div class="dialog_body">
          <img v-if="qrCode" class="qrcodeImg" :src="qrCode" alt="">
          <div class="loadingText" v-else>
            {{ loadingText }}
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="dialog">
      <el-dialog title="批量检测状态"
                 :visible.sync="batchUpdateADSVisible"
                 custom-class="common-dialog"
                 :close-on-click-modal="false"
                 @close="resetForm('batchForm')"
                 width="400px">
        <div>
          <el-form label-position="right" status-icon label-width="90px"
                   :model="batchForm" ref="batchForm" class="form-container">
            <el-form-item label="是否检测:" prop="isItChecked"
                          :rules="[{ required: true, message: '检测状态不能为空', trigger: 'change'}]">
              <el-select v-model="batchForm.isItChecked" placeholder="请选择检测状态">
                <el-option :key="1" label="是" :value="1"/>
                <el-option :key="0" label="否" :value="0"/>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="batchUpdateADSVisible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submitADSBatch('batchForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="dialog">
      <el-dialog title="批量修改分组"
                 :visible.sync="batchUpdateADSGroupVisible"
                 custom-class="common-dialog"
                 :close-on-click-modal="false"
                 @close="resetForm('batchGroupForm')"
                 width="400px">
        <div>
          <el-form label-position="right" status-icon label-width="90px"
                   :model="batchGroupForm" ref="batchGroupForm" class="form-container">
            <el-form-item label="分组名称:" prop="systemGroupId"
                          :rules="[{ required: true, message: '分组名称不能为空', trigger: 'change'}]">
              <el-select v-model="batchGroupForm.systemGroupId" placeholder="请选择分组名称"
                         clearable
                         size="medium"
                         class="mr10 mb-10">
                <el-option
                    v-for="(option, index) in groupIds"
                    :key="index"
                    :label="option.name"
                    :value="option.id"
                />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="batchUpdateADSGroupVisible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submitADSGroupBatch('batchGroupForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="dialog">
      <el-dialog title="修改cookie"
                 :visible.sync="updateCookieVisible"
                 custom-class="common-dialog"
                 :close-on-click-modal="false"
                 @close="resetForm('updateCookieForm')"
                 width="30%">

        <div class="dialog_body">
          <el-form label-position="right" status-icon label-width="90px"
                   :model="updateCookieForm" ref="updateCookieForm">
            <el-form-item label="cookie" prop="cookie"
                          :rules="[{ required: true, message: 'cookie不能为空', trigger: 'blur'}]">
              <el-input type="text" :rows="50" v-model="updateCookieForm.cookie" placeholder="请输入cookie"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="updateCookieVisible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submitCookieBatch('updateCookieForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="dialog">
      <el-dialog title="批量发布"
                 :visible.sync="batchReleaseVisible"
                 custom-class="common-dialog"
                 :close-on-click-modal="false"
                 @close="resetForm('batchReleaseForm')"
                 width="600px">
        <div>
          <el-form label-position="right" status-icon label-width="90px"
                   :model="batchReleaseForm" ref="batchReleaseForm" class="form-container">
            <el-form-item label="发布数量:" prop="batchCount"
                          :rules="[{ required: true, message: '批量发布数量不能为空', trigger: 'blur'}]">
              <el-input v-model="batchReleaseForm.batchCount" placeholder="请输入批量发布数量"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="batchReleaseVisible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submitBatchRelease('batchReleaseForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>


<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import request from "@/utils/axios";
import message from "@/utils/message";

export default {
  name: 'ADSEnvironment',
  components: {CommonTable},
  data() {
    return {
      batchReleaseVisible: false,
      batchReleaseForm: {
        batchCount: null
      },
      showLoginDialog: false,
      batchUpdateADSVisible: false,
      batchUpdateADSGroupVisible: false,
      updateCookieVisible: false,
      selectIds: [],
      batchForm: {
        ids: '',
        isItChecked: null
      },
      batchGroupForm: {
        ids: '',
        systemGroupId: null,
      },

      updateCookieForm: {
        id: '',
        ids: '',
        cookie: null,
      },
      groupIds: [],
      qrCode: null,
      loadingText: '正在加载中',
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }, {
        name: 'name',
        placeholder: '环境名称',
        type: 'input'
      }, {
        name: 'appUserPhone',
        placeholder: '用户手机号',
        type: 'input'
      }, {
        name: 'remark',
        placeholder: '账号信息',
        type: 'input'
      }, {
        name: 'platformType',
        placeholder: '平台类型',
        type: 'select',
        selectValue: [{
          key: 1,
          value: '抖音',
        }, {
          key: 2,
          value: '快手',
        }]
      }, {
        name: 'sorts',
        placeholder: '排序',
        type: 'select',
        selectValue: [{
          key: "cookie",
          value: '视频稽核',
        }]
      }, {
        name: 'publishStatus',
        placeholder: '发布状态',
        type: 'select',
        selectValue: [{
          key: 1,
          value: '未发布',
        }, {
          key: 2,
          value: '发布中',
        }, {
          key: 3,
          value: '发布完成',
        }]
      }, {
        name: 'accountStatus',
        placeholder: '账号状态',
        type: 'select',
        selectValue: [{
          key: 1,
          value: '启用',
        }, {
          key: 0,
          value: '暂停',
        }]
      }, {
        name: 'numberOfReleases',
        placeholder: '发布数量',
        type: 'input'
      }, {
        name: 'systemGroupId',
        placeholder: '分组名称',
        type: 'select',
        selectUrl: '/aDSEnvironmentGroup/getAll',
        selectData: [],
      }],
      permission: {
        add: 'aDSEnvironment:add',
        update: 'aDSEnvironment:update',
        delete: 'aDSEnvironment:delete',
        deleteBatch: 'aDSEnvironment:deleteBatch'
      },
      url: {
        get: '/aDSEnvironment/listByCondition',
        add: '/aDSEnvironment/add',
        update: '/aDSEnvironment/update',
        delete: '/aDSEnvironment/delete',
        delete_batch: '/aDSEnvironment/deleteBatch',
        status: '/aDSEnvironment/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
        sortable: true
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      },
        {
          field: 'userId',  // 字段名
          label: '环境ID',  // 字段显示名称
          sort: false,  // 是否排序
          show: false,  // 是否展示
        }, 
        {
          field: 'appUserId',
          label: '用户ID',
          sort: false,
          show: false,
          detail: true,
        },
        {
          field: 'appUserPhone',
          label: '用户手机号',
          sort: false,
          show: false,
          detail: true,
        },
        {
          field: 'serialNumber',  // 字段名
          label: '环境编号',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
          sortable: true
        }, {
          field: 'name',  // 字段名
          label: '环境名称',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'systemGroupId',  // 字段名
          label: '分组名称',  // 字段显示名称
          selectUrl: '/aDSEnvironmentGroup/getAll',
          selectData: [],
          show: {
            type: 'select',
          },
        }, {
          field: 'groupName',  // 字段名
          label: '分组名称',  // 字段显示名称
          sort: false,  // 是否排序
          show: false,  // 是否展示
        }, {
          field: 'domainName',  // 字段名
          label: '默认打开的网址',  // 字段显示名称
          sort: false,  // 是否排序
          show: false,  // 是否展示
        },
        // {
        //   field: 'ip',  // 字段名
        //   label: '代理IP',  // 字段显示名称
        //   sort: false,  // 是否排序
        //   show: true,  // 是否展示
        // },
        // {
        //   field: 'ipCountry',  // 字段名
        //   label: '代理国家/地区',  // 字段显示名称
        //   sort: false,  // 是否排序
        //   show: false,  // 是否展示
        //   detail: false,
        // },
        // {
        //   field: 'username',  // 字段名
        //   label: '代理账号',  // 字段显示名称
        //   sort: false,  // 是否排序
        //   show: true,  // 是否展示
        //   detail: false,
        // },
        // {
        //   field: 'password',  // 字段名
        //   label: '代理密码',  // 字段显示名称
        //   sort: false,  // 是否排序
        //   show: true,  // 是否展示
        //   detail: false,
        // },
        {
          field: 'remark',  // 字段名
          label: '账号信息',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'lastOpenTime',  // 字段名
          label: ' 最近一次打开时间',  // 字段显示名称
          sort: false,  // 是否排序
          show: false,  // 是否展示
        }, {
          field: 'sysAppCateId',  // 字段名
          label: 'sysAppCateId',  // 字段显示名称
          sort: false,  // 是否排序
          show: false,  // 是否展示
        }, {
          field: 'cookie',  // 字段名
          label: '视频稽核',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
          detail: true,
        },
        // {
        //   field: 'callbackTime',  // 字段名
        //   label: 'cookies更新时间',  // 字段显示名称
        //   sort: false,  // 是否排序
        //   show: true,  // 是否展示
        //   detail: false,
        // }, {
        //   field: 'detectionTime',  // 字段名
        //   label: '检测时间',  // 字段显示名称
        //   sort: false,  // 是否排序
        //   show: true,  // 是否展示
        //   detail: false,
        // },
        {
          field: 'isItChecked',  // 字段名
          label: '是否检测',  // 字段显示名称
          width: '90',
          status: true,
          sort: false,  // 是否排序
          show: true,  // 是否展示
          detail: false,
          sortable: true
        }, {
          field: 'isItChecked',  // 字段名
          label: '是否检测',  // 字段显示名称
          width: '90',
          // status: true,
          sort: false,  // 是否排序
          show: false,
          detail: false,
          sortable: true
        }, {
          field: 'numberOfReleases',  // 字段名
          label: '今日视频发布数',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
          detail: false,
          sortable: true
        }, {
          field: 'numberOfVideoReleasesToday',  // 字段名
          label: '今日视频发布数统计',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
          detail: false,
        },
        {
          field: 'publishStatus',
          label: '发布状态',
          show: {
            type: 'select'
          },
          selectData: [
            { id: 1, name: '未发布' },
            { id: 2, name: '发布中' },
            { id: 3, name: '发布完成' }
          ]
        },
        {
          field: 'accountStatus',
          label: '账号状态',
          show: true,
          status: true
        },
        // {
        //   field: 'taskStatus',  // 字段名
        //   label: '任务状态',  // 字段显示名称
        //   show: false,
        //   detail: false,
        //   width: '90',
        //   status: true,
        // },
        // {
        //   field: 'qrCodeStatus',  // 字段名
        //   label: '二维码状态',  // 字段显示名称
        //   show: {
        //     type: 'select',
        //   },
        //   selectData: [{
        //     id: 1,
        //     name: '获取中'
        //   }, {
        //     id: 0,
        //     name: '未获取'
        //   }],
        // },
        // {
        //   field: 'status',  // 字段名
        //   label: '账户状态',  // 字段显示名称
        //   show: {
        //     type: 'select',
        //   },
        //   selectData: [{
        //     id: 1,
        //     name: '正常'
        //   }, {
        //     id: 0,
        //     name: '掉线'
        //   }],
        // },
        //  {
        //   field: 'qrCode',  // 字段名
        //   label: '登录二维码',  // 字段显示名称
        //   show: true,
        //   loginCode: true,
        //   detail: false,
        //   width: '90',
        // },
        // {
        //   field: 'platformType',  // 字段名
        //   label: '平台类型',  // 字段显示名称
        //   sort: false,  // 是否排序
        //   show: {
        //     type: 'select',
        //   },
        //   selectData: [{
        //     id: 1,
        //     name: '抖音'
        //   }, {
        //     id: 2,
        //     name: '快手'
        //   }],
        // },
        {
          field: 'fansNumber',  // 字段名
          label: '粉丝数',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
          sortable: true
        }, {
          field: 'phone',  // 字段名
          label: '手机号',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'pwd',  // 字段名
          label: '密码',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'msg',  // 字段名
          label: '备注',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }
      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: false
          }, {
            field: 'agentId',
            label: '代理：',
            type: 'select',
            placeholder: '请选择代理',
            rules: [{required: true, message: '请选择代理', trigger: 'blur'}],
            selectUrl: '/agent/getAll',
            selectData: [],
            add: true,
            update: true,
            filterable: true,
          },
          {
            field: 'userId',  // 字段名
            label: '环境ID',  // 字段显示名称
            type: 'input',
            placeholder: '请输入userId',
            rules: [
              {required: false, message: 'userId不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'serialNumber',  // 字段名
            label: '环境编号',  // 字段显示名称
            type: 'input',
            placeholder: '请输入环境编号',
            rules: [
              {required: false, message: '环境编号不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'name',  // 字段名
            label: '环境名称',  // 字段显示名称
            type: 'input',
            placeholder: '请输入环境名称',
            rules: [
              {required: false, message: 'name不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'systemGroupId',  // 字段名
            label: '分组名称',  // 字段显示名称
            type: 'select',
            placeholder: '请选择分组名称',
            selectUrl: '/aDSEnvironmentGroup/getAll',
            selectData: [],
            rules: [
              {required: false, message: 'groupId不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'groupName',  // 字段名
            label: '分组名称',  // 字段显示名称
            type: 'input',
            placeholder: '请输入分组名称',
            rules: [
              {required: false, message: '分组名称不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'domainName',  // 字段名
            label: '默认打开的网址',  // 字段显示名称
            type: 'input',
            placeholder: '请输入域名',
            rules: [
              {required: false, message: 'domainName不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'ip',  // 字段名
            label: '代理IP',  // 字段显示名称
            type: 'input',
            placeholder: '请输入ip',
            rules: [
              {required: false, message: 'ip不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'ipCountry',  // 字段名
            label: '代理国家/地区',  // 字段显示名称
            type: 'input',
            placeholder: '请输入ipCountry',
            rules: [
              {required: false, message: 'ipCountry不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'username',  // 字段名
            label: '代理账号',  // 字段显示名称
            type: 'input',
            placeholder: '请输入账号',
            rules: [
              {required: false, message: 'username不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'password',  // 字段名
            label: '代理密码',  // 字段显示名称
            type: 'input',
            placeholder: '请输入密码',
            rules: [
              {required: false, message: 'password不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'remark',  // 字段名
            label: '账号信息',  // 字段显示名称
            type: 'input',
            placeholder: '请输入账号信息',
            rules: [
              {required: false, message: 'remark不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'cookie',  // 字段名
            label: 'cookie',  // 字段显示名称
            type: 'textarea',
            placeholder: '请输入cookie',
            rules: [
              {required: false, message: 'cookie不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'lastOpenTime',  // 字段名
            label: 'lastOpenTime',  // 字段显示名称
            type: 'input',
            placeholder: '请输入lastOpenTime',
            rules: [
              {required: false, message: 'lastOpenTime不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'sysAppCateId',  // 字段名
            label: 'sysAppCateId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入sysAppCateId',
            rules: [
              {required: false, message: 'sysAppCateId不能为空', trigger: 'blur'}
            ],
            add: false,
            update: false,
          }, {
            field: 'numberOfReleases',  // 字段名
            label: '今日视频发布数',  // 字段显示名称
            type: 'input',
            placeholder: '请输入视频发布阈值',
            rules: [
              {required: true, message: '视频发布阈值不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },{
            field: 'videoPublishingThreshold',  // 字段名
            label: '视频发布阈值',  // 字段显示名称
            type: 'input',
            placeholder: '请输入视频发布阈值',
            rules: [
              {required: true, message: '视频发布阈值不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'publishStatus',
            label: '发布状态',
            type: 'select',
            placeholder: '请选择发布状态',
            selectData: [
              { id: 1, name: '未发布' },
              { id: 2, name: '发布中' },
              { id: 3, name: '发布完成' }
            ],
            add: true,
            update: true
          }, {
            field: 'accountStatus',
            label: '账号状态',
            type: 'select',
            placeholder: '请选择账号状态开关',
            selectData: [
              { id: 1, name: '启用' },
              { id: 0, name: '暂停' }
            ],
            add: true,
            update: true
          }, {
            field: 'status',
            label: '账户状态：',
            type: 'select',
            placeholder: '请选择账户状态',
            rules: [{required: true, message: '账户状态不能为空', trigger: 'blur'}],
            selectData: [{
              id: 1,
              name: '正常'
            }, {
              id: 0,
              name: '掉线'
            }],
            // add: true,
            update: true,
            filterable: true,
          }, {
            field: 'platformType',  // 字段名
            label: '平台',  // 字段显示名称
            type: 'select',
            placeholder: '请选择平台',
            rules: [
              {required: true, message: '平台不能为空', trigger: 'blur'}
            ],
            selectData: [{
              id: 1,
              name: '抖音'
            }, {
              id: 2,
              name: '快手'
            }],
            add: true,
            update: true,
          }, {
            field: 'fansNumber',  // 字段名
            label: '粉丝数',  // 字段显示名称
            type: 'input',
            placeholder: '请输入粉丝数',
            rules: [
              {required: false, message: '粉丝数不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },{
            field: 'phone',  // 字段名
            label: '手机号',  // 字段显示名称
            type: 'input',
            placeholder: '请输入手机号',
            rules: [
              {required: false, message: '手机号不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },{
            field: 'pwd',  // 字段名
            label: '密码',  // 字段显示名称
            type: 'input',
            placeholder: '请输入密码',
            rules: [
              {required: false, message: '密码不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },{
            field: 'msg',  // 字段名
            label: '备注',  // 字段显示名称
            type: 'input',
            placeholder: '请输入备注',
            rules: [
              {required: false, message: '备注不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: [{
        icon: 'el-icon-lock',
        type: 'text',
        text: '登录',
        exist: (row) => {
          return row.status === 0 && this.$refs.table.havePermission('aDSEnvironment:update')
        },
        handle: (row) => {
          if (row.status != 0) {
            message.warning("已登录，不可重复操作");
            return;
          }
          this.qrCode = null
          this.showLoginDialog = true
          this.getQrcode(row)
          // if (row.status != 0) {
          //   message.warning("已登录，不可重复操作");
          //   return;
          // }
          // request.post({
          //   url: '/aDSEnvironment/login',
          //   data: {id: row.id, qrCodeStatus: 1},
          //   success: (data) => {
          //     if (data.code == 0) {
          //       message.success("操作成功");
          //       this.$refs.table.getData();
          //     } else {
          //       message.error("操作失败");
          //     }
          //   }
          // });

        }
      }, {
        icon: 'el-icon-lock',
        type: 'text',
        text: '修改cookie',
        exist: () => {
          return this.$refs.table.havePermission('aDSEnvironment:update')
        },
        handle: (row) => {
          this.updateCookieForm.id = row.id;
          this.updateCookieForm.cookie = row.cookie;
          this.updateCookieVisible = true
        }
      }],
      buttons: [{
        icon: 'el-icon-circle-check',
        type: 'success',
        text: '批量发布',
        permission: 'aDSEnvironment:update',
        click: () => {
          console.log(this.selectIds)
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要修改的数据')
            return
          }
          this.batchReleaseVisible = true
        }
      }, {
        icon: 'el-icon-info',
        type: 'info',
        text: '批量更新检测',
        permission: 'aDSEnvironment:update',
        click: () => {
          console.log(this.selectIds)
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要修改的数据')
            return
          }
          this.batchUpdateADSVisible = true
        }
      }, {
        icon: 'el-icon-circle-check',
        type: 'success',
        text: '批量修改分组',
        permission: 'aDSEnvironment:update',
        click: () => {
          console.log(this.selectIds)
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要修改的数据')
            return
          }
          request.post({
            url: '/aDSEnvironmentGroup/getAll',
            success: (res) => {
              if (res.code === 0) {
                console.log(res.data, 123123)
                this.groupIds = res.data
                this.batchUpdateADSGroupVisible = true
              } else {
                message.error(res.msg);
              }
            }
          });
        }
      }, {
        icon: 'el-icon-info',
        type: 'info',
        text: '批量清空视频稽核',
        permission: 'aDSEnvironment:update',
        click: () => {
          console.log(this.selectIds)
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要修改的数据')
            return
          }
          this.updateCookieForm.ids = this.selectIds.join(",")
          request.post({
            url: '/aDSEnvironment/batchUpdateCookie',
            data: this.updateCookieForm,
            success: (res) => {
              if (res.code === 0) {
                message.success("批量批量清空视频稽核成功");
                this.$refs.table.getData()
              } else {
                message.error(res.msg);
              }
            }
          });
        }
      }/*{
        icon: 'el-icon-download',
        type: 'warning',
        text: '更新环境',
        permission: 'aDSEnvironment:update',
        click: () => {
          request.get({
            url: '/aDSEnvironment/updateList',
            success: (data) => {
              if (data.code == 0) {
                message.success("操作成功");
                this.$refs.table.getData();
              } else {
                message.error("操作失败");
              }
            }
          });
        }
      }*/]
    }
  },
  methods: {
    returnId(data) {
      this.selectIds = data;
      console.log(this.selectIds)
    },
    //重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitADSBatch(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.batchForm.ids = this.selectIds.join(",")
          request.post({
            url: '/aDSEnvironment/batchUpdateIsItChecked',
            data: this.batchForm,
            confirm: '确定修改检测状态？',
            success: (res) => {
              if (res.code === 0) {
                message.success("批量修改检测状态成功");
                this.batchUpdateADSVisible = false;
                this.$refs.table.getData()
              } else {
                message.error(res.msg);
              }
            }
          })
        }
      })
    },
    submitADSGroupBatch(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.batchGroupForm.ids = this.selectIds.join(",")
          request.post({
            url: '/aDSEnvironment/batchUpdateGroup',
            data: this.batchGroupForm,
            confirm: '确定修改分组？',
            success: (res) => {
              if (res.code === 0) {
                message.success("批量修改分组成功");
                this.batchUpdateADSGroupVisible = false;
                this.$refs.table.getData()
              } else {
                message.error(res.msg);
              }
            }
          })
        }
      })
    },
    submitCookieBatch(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          request.post({
            url: '/aDSEnvironment/update',
            data: this.updateCookieForm,
            confirm: '确定修改cookie？',
            success: (res) => {
              if (res.code === 0) {
                message.success("修改cookie成功");
                this.updateCookieVisible = false;
                this.$refs.table.getData()
              } else {
                message.error(res.msg);
              }
            }
          })
        }
      })
    },

    getQrcode(row) {
      request.get({
        url: '/api/live/getQrcode/' + row.id,
        loading: false,
        success: (data) => {
          console.log(data, 111111111)
          if (data.data.qrCode) {
            this.qrCode = data.data.qrCode
          } else {
            if (this.showLoginDialog) {
              setTimeout(() => {
                this.getQrcode(row)
                let matches = this.loadingText.match(/\./g);
                var dotCount = matches ? matches.length : 0;
                if (dotCount < 3) {
                  this.loadingText = this.loadingText + '.'
                } else {
                  this.loadingText = '正在加载中'
                }

              }, 1000)
            }


            // message.error("二维码不存在");
          }
          // if (data.code == 0) {
          //   message.success("操作成功");
          //   this.$refs.table.getData();
          // } else {
          //   message.error("操作失败");
          // }
        }
      });
    }, submitBatchRelease(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.batchReleaseForm.ids = this.selectIds.join(",")
          request.post({
            url: '/aDSEnvironment/batchRelease',
            data: this.batchReleaseForm,
            success: (res) => {
              if (res.code === 0) {
                message.success(res.data);
                this.batchReleaseVisible = false;
                this.$refs.table.getData()
              } else {
                message.error(res.msg);
              }
            }
          })
        }
      })
    },
  }
}
</script>

<style scoped>
.dialog {
  max-width: 400px;
}

.form-container {
  padding: 20px;
}

.dialog-footer {
  text-align: right;
  padding: 10px 20px;
}

.el-button {
  margin-left: 10px;
}

.el-button:first-child {
  margin-left: 0;
}
</style>
